import styled from 'styled-components';

import { DivisorProps } from './types';

export const Divisor = styled.hr<DivisorProps>`
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  margin: ${({ theme, marginBlock }) =>
    !marginBlock && `${theme.yoga.spacing.zero}`};
`;
